import React from 'react';
import { hotelData } from '../data/hotelData';
import { motion } from 'framer-motion';

const Experiences = () => {
  return (
    <section className="section-padding bg-luxury-black text-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <span className="subheading-premium">
            Special Moments
          </span>
          <h2 className="heading-premium text-white">
            Experiences & Events
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {hotelData.experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="relative group h-[500px] rounded-xl overflow-hidden cursor-pointer shadow-[0_10px_30px_rgba(0,0,0,0.5)] border border-white/10"
            >
              <img 
                src={exp.image} 
                alt={exp.title} 
                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110 opacity-60"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-luxury-black via-transparent to-transparent" />
              
              <div className="absolute bottom-0 left-0 w-full p-8 translate-y-6 group-hover:translate-y-0 transition-transform duration-500 bg-gradient-to-t from-black via-black/80 to-transparent">
                <h3 className="text-3xl font-serif text-white mb-3 tracking-wide">{exp.title}</h3>
                <p className="text-gray-300 text-sm mb-6 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 font-light tracking-wide">
                  {exp.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {exp.packages.map((pkg, i) => (
                    <span key={i} className="text-[10px] uppercase font-bold tracking-widest border border-white/30 px-3 py-1 rounded-full">
                      {pkg}
                    </span>
                  ))}
                </div>
                <button className="text-orange-400 tracking-[2px] text-xs font-bold flex items-center gap-2 group/btn">
                  Explore Now
                  <div className="w-8 h-[1px] bg-orange-400 group-hover/btn:w-12 transition-all duration-300 shadow-[0_0_10px_rgba(249,115,22,0.8)]" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experiences;
